import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

import { IIconNav } from './icon.nav.interface';
import { fadeAnimation } from './../../../shared/animations/fade.animation';
import { IIcon } from './../../atoms/icon/icon.interface';

@Component({
    selector: 'mlp-ng-icon-nav',
    templateUrl: './icon.nav.component.html',
    styleUrls: ['./icon.nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [fadeAnimation]
})

export class IconNavSharedComponent {
    hidden = true;
    openIcon: IIcon = { name: 'navigation-menu-horizontal' };
    closeIcon: IIcon = { name: 'close' };
    @Output() visibility = new EventEmitter<boolean>();

    @Input() links: Array<IIconNav>;

    toggleNav(status?: boolean): void {
        this.hidden = (status) ? status : !this.hidden;
        this.visibility.emit(this.hidden);
    }
}
